class DeviceManager {
    constructor() {

        if (DeviceManager.instance) {
            return DeviceManager.instance;
        }
        DeviceManager.instance = this;

        this.tizenUserAgent = {
            "Tizen 8.0": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 8.0) AppleWebKit/537.36 (KHTML, like Gecko) 108.0.5359.1/8.0 TV Safari/537.36",
            "Tizen 7.0": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 7.0) AppleWebKit/537.36 (KHTML, like Gecko) 94.0.4606.31/7.0 TV Safari/537.36",
            "Tizen 6.5": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 6.5) AppleWebKit/537.36 (KHTML, like Gecko) 85.0.4183.93/6.5 TV Safari/537.36",
            "Tizen 6.0": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 6.0) AppleWebKit/537.36 (KHTML, like Gecko) 76.0.3809.146/6.0 TV Safari/537.36",
            "Tizen 5.5": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 5.5) AppleWebKit/537.36 (KHTML, like Gecko) 69.0.3497.106.1/5.5 TV Safari/537.36",
            "Tizen 5.0": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 5.0) AppleWebKit/537.36 (KHTML, like Gecko) Version/5.0 TV Safari/537.36",
            "Tizen 4.0": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 4.0) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 TV Safari/537.36",
            "Tizen 3.0": "Mozilla/5.0 (SMART-TV; LINUX; Tizen 3.0) AppleWebKit/538.1 (KHTML, like Gecko) Version/3.0 TV Safari/538.1",
            "Tizen 2.4": "Mozilla/5.0 (SMART-TV; Linux; Tizen 2.4.0) AppleWebKit/538.1 (KHTML, like Gecko) Version/2.4.0 TV Safari/538.1"
        };

        this.webOSUserAgent = {
            "webOS TV 24": "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/108.0.5359.211 Safari/537.36 WebAppManager",
            "webOS TV 23": "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.128 Safari/537.36 WebAppManager",
            "webOS TV 22": "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.88 Safari/537.36 WebAppManager",
            "webOS TV 6.x": "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/79.0.3945.79 Safari/537.36 WebAppManager",
            "webOS TV 5.x": "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/68.0.3440.106 Safari/537.36 WebAppManager",
            "webOS TV 4.x": "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.34 Safari/537.36 WebAppManager"
        };


        this.userAgent = navigator.userAgent;
    }

    isSamsung() {
        return this.userAgent.includes("Samsung") || this.userAgent.includes("Tizen");
    }

    isLG() {
        let isLG = false;
        let userAgent = this.userAgent.toLowerCase();
        if(userAgent.includes("lg") || userAgent.includes("webos") || userAgent.includes("web0s")) {
            isLG = true;
        } else {
            console.log("Not LG");
        }
        return isLG;
    }


    initTizenAPI() {
        try {
            if (typeof window.webapis !== "undefined") {
                const webapis = window.webapis;
                const macAddress = webapis.network.getMac();
                const getModel = webapis.network.getVersion();
                const getVersion = webapis.appcommon.getVersion();
                const getUuid = webapis.appcommon.getUuid();
                const getIp = webapis.network.getIp();
                const getProductInfo = webapis.productinfo.getRealModel();
                const getFirmVersion = webapis.productinfo.getFirmware();
                const getModelCode = webapis.productinfo.getModelCode();

                // Store all the values in localStorage
                localStorage.setItem('macAddress_', macAddress);
                localStorage.setItem('model', getModel);
                localStorage.setItem('version', getVersion);
                localStorage.setItem('uuid_', getUuid);
                localStorage.setItem('ip', getIp);
                localStorage.setItem('productInfo', getProductInfo);
                localStorage.setItem('firmVersion', getFirmVersion);
                localStorage.setItem('modelCode', getModelCode);
            }

        } catch (error) {
            console.error("Failed to retrieve and store device information: " + error.message);
        }
    }

    initWebOSAPI() {
        try {
            if (typeof window.webOS !== "undefined") {
                // Get device info (asynchronous)
                window.webOS.deviceInfo((device) => {
                    // Get network info (requires webOS 4.0+)
                    const connection = window.webOS.networkConnection || navigator.connection;
                    
                    // Store values in localStorage
                    // localStorage.setItem('model', device.modelName || '');
                    // localStorage.setItem('version', device.version || '');
                    // localStorage.setItem('uuid', device.UUID || '');
                    
                    if (connection) {
                        // localStorage.setItem('ip', connection.ipAddress || '');
                        // localStorage.setItem('macAddress', connection.macAddress || '');
                    }
                    
                    // Additional product info
                    // localStorage.setItem('productInfo', device.modelName || '');
                    // localStorage.setItem('firmVersion', device.version || '');
                    // localStorage.setItem('modelCode', device.modelName || ''); // webOS doesn't expose model code directly
                    
                    // For newer webOS versions (5.0+)
                    // if (window.webOS.system) {
                    //     window.webOS.system.getProperty('modelName', (model) => {
                    //         localStorage.setItem('model', model);
                    //     });
                    //     window.webOS.system.getProperty('firmwareVersion', (firmware) => {
                    //         localStorage.setItem('firmVersion', firmware);
                    //     });
                    // }
                });
                
                // For webOS TV specific features
                if (window.webOS.tv) {
                    window.webOS.tv.channel.tune((info) => {
                        // Can store channel info if needed
                    });
                }
            }
        } catch (error) {
            console.error("Failed to retrieve and store LG device information: " + error.message);
        }
    }

    getTizenVersion() {
        let TIZEN_LIST = [{
            version: "Tizen 8.0",
            match: "Tizen 8.0"
        },
        {
            version: "Tizen 7.0",
            match: "Tizen 7.0"
        },
        {
            version: "Tizen 6.5",
            match: "Tizen 6.5"
        },
        {
            version: "Tizen 6.0",
            match: "Tizen 6.0"
        },
        {
            version: "Tizen 5.5",
            match: "Tizen 5.5"
        },
        {
            version: "Tizen 5.0",
            match: "Tizen 5.0"
        },
        {
            version: "Tizen 4.0",
            match: "Tizen 4.0"
        },
        {
            version: "Tizen 3.0",
            match: "Tizen 3.0"
        },
        {
            version: "Tizen 2.4",
            match: "Tizen 2.4"
        }
        ];
        for (let i = 0; i < TIZEN_LIST.length; i++) {
            if (this.userAgent.includes(TIZEN_LIST[i].match)) {
                return TIZEN_LIST[i].version;
            }
        }
        return null;
    }

    getWebOsVersion() {
        let WEBOS_LIST = [
            { version: "webOS TV 24", match: "Chrome/108" },
            { version: "webOS TV 23", match: "Chrome/94" },
            { version: "webOS TV 22", match: "Chrome/87" },
            { version: "webOS TV 6.x", match: "Chrome/79" },
            { version: "webOS TV 5.x", match: "Chrome/68" },
            { version: "webOS TV 4.x", match: "Chrome/53" }
        ];
        for (let i = 0; i < WEBOS_LIST.length; i++) {
            if (this.userAgent.includes(WEBOS_LIST[i].match)) {
                return WEBOS_LIST[i].version;
            }
        }
        return null;
    }
}

export { DeviceManager };